import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AddRole, PermRole, RemoveRole, UserData, UserRole } from 'src/app/models/user-data.model';
import { AddRoleFormComponent } from './add-role-form.component';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { UserCardComponent } from '@/global/user-card.component';
import { UsersService } from '@/services/api/users.service';
import { AppAuthService } from '@/services/app/auth.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { UserRolesListService } from '@/services/api/user-roles-list.service';
import { OfficeUsersService } from '@/services/app/office-users.service';
import { PermissionsListComponent } from '../user-components/permissions-list.component';

@Component({
    selector: 'app-user-editor',
    imports: [
        CommonModule,
        UserCardComponent,
        AddRoleFormComponent,
        PermissionsListComponent,
        ScrollPanelModule,
        ButtonModule,
        FieldsetModule,
        ScrollPanelModule
    ],
    standalone: true,
    template: `
    
<div>
    <app-user-card [user]="selectedUser"></app-user-card>

    <div class="mt-4">
        <p-fieldset  legend="Add Roles" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="toggleAddRoleForm()">
            <app-add-role-form [resetFormTrigger]="resetFormTrigger" (addRole)="onAddRole($event)"></app-add-role-form>
        </p-fieldset>
    </div>
    
    <div class="mt-4">
        <p-scrollPanel [style]="{ width: '100%', height: '50vh' }" styleClass="custombar">
            <app-permissions-list></app-permissions-list>
        </p-scrollPanel>
    </div>
</div>
<div class="footer flex align-items-center surface-card">
    <div class="ml-auto">
        <p-button label="Save User" (onClick)="onSave()"></p-button>
    </div>
</div>

    `,
    styles: `
    .p-fieldset .p-fieldset-toggleable {
    border-style: none;
}
.footer {
    position: sticky;
    bottom: 0;
    padding: 1em;
}
    `
})
export class UserEditorComponent {
  userListService = inject(UsersService);
  userRolesListService = inject(UserRolesListService);
  officeUsersService = inject(OfficeUsersService);
  addRoles: AddRole[] = [];
  removeRoles: RemoveRole[] = [];

  resetFormTrigger: boolean = false;

  showAddRoleForm: boolean = false;

  constructor(

  ) {
    effect(() => {
      if(this.selectedUser) {
        this.addRoles = [];
        this.removeRoles = [];
      }
    })
  }

  get selectedUser() {
    return this.officeUsersService.selectedUser();
  }

  get roles() {
    return this.officeUsersService.getFilteredRoles();
  }

  get inSystem() {
    if(!this.selectedUser?.UID) {
      return false;
    } else {
      return true;
    }
  }

  get includedFids() {
    if(!this.selectedUser?.UserRoles) {
      return [];
    }
    return this.selectedUser.UserRoles.map(role => role.PermRoles.FID).filter(fid => fid !== null) as number[];
  }

  addRole(role:AddRole) {
    const inviteRequired = !this.checkAlreadyInOffice(role.FID);
    role.inviteRequired = inviteRequired;
    const remove = this.removeRoles.find(r => r.PermRoleID === role.PermRoleID && r.FID === role.FID);
    if(remove) {
      this.removeRoles.splice(this.removeRoles.indexOf(remove), 1);
    }
    this.addRoles.push(role);
    console.log('addRoles',this.addRoles)
  }

  removeRole(role:UserRole) {
    const add = this.addRoles.find(r => r.PermRoleID === role.PermRoleID && r.FID === role.PermRoles.FID);
    if(add) {
      this.addRoles.splice(this.addRoles.indexOf(add), 1);
    }
    const remove = {
      UserRoleID: role.UserRoleID,
      PermRoleID: role.PermRoleID,
      FID: role.PermRoles?.FID
    }
    this.removeRoles.push(remove);
    console.log('removeRoles',this.removeRoles)
  }

  toggleAddRoleForm() {
    this.resetFormTrigger = true;
    this.showAddRoleForm = !this.showAddRoleForm;
  }

  checkAlreadyInOffice(fid:number | null) {
    if(!this.selectedUser?.UserRoles || fid === null) {
      return false;
    }
    return this.includedFids.includes(fid)
  }

  async onSave() {
    console.log('removeRoles',this.removeRoles)
    const userData = {
      UID: this.selectedUser!.UID,
      addRoles: this.addRoles,
      removeRoles: this.removeRoles,
      sendInvite: false
    }
    console.log('userData',userData);
  }

  onRemoveRole(event:any) {
    console.log('onRemoveRole',event)
    this.removeRole(event);
    this.userRolesListService.removeRole(event);
  }

  onAddRole(data:{role:PermRole,addRole:AddRole}) {
  }


  inviteUser() {}

}
